module.exports = __webpack_public_path__ + "static/media/profile-picture-2.95cc79ae.jpg";